<script>
import Axios from "axios";
import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import { authComputed } from '@state/helpers';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';

export default {
  page: {
    title: 'Vocento Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      userId: 0,
      disabledBefore: new Date(2021, 2, 1),
      loading: true,
      title: 'Dashboard',
      items: [
        {
          text: 'Unblockia',
          href: '/',
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      shortcuts: [
        {
          text: 'Yesterday',
          onClick: () => {
            this.selectedDate = [new Date(this.yesterday), new Date(this.yesterday)];
            return 'Yesterday';
          },
        },
        {
          text: 'Last 7 days',
          onClick: () => {
            this.selectedDate = [new Date(this.sevenDaysAgo), new Date(this.yesterday)];
            return this.yesterday;
          },
        },
        {
          text: 'Last 30 days',
          onClick: () => {
            this.selectedDate = [new Date(this.thirtyDaysAgo), new Date(this.yesterday)];
            return this.thirtyDaysAgo;
          },
        },
      ],
      perPage: 25,
      currentPage: 1,
      sortBy: 'domain',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      showCalculator: false,
      usdInput: 0,
      usdDisplay: '',
      rateInput: 0,
      rateDisplay: '',
      checkCurrency: '',
      currencyAlert: '',
      showEmbeddedContainer: false,
      embedLoading: false
      }
  },
  computed: {
    canSeeVocentoDashboard: function() {
      return JSON.parse(localStorage["auth.currentUser"]).name === "Vocento" || this.isAdmin
    },
    mode: function() {
      if (this.isAdmin) {
        return this.seeAs || 'admin'
      }

      return JSON.parse(localStorage["auth.currentUser"]).role.name
    },

    ...authComputed,
    isAdmin: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "admin"
    },
    isFinance: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "finance"
    },
    isEyeo: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "eyeo"
    },
    isUser: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "user"
    },
    isMediaBuyer: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "media buyer"
    },
    isAccountManager: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "account manager"
    },
    isTrafficker: () => {
      return JSON.parse(localStorage["auth.currentUser"]).role.name === "trafficker"
    },
    fromTo: function () {
      return `from=${this.prettyDate(this.selectedDate[0])}&to=${this.prettyDate(this.selectedDate[1])}`
    },
    rows(){
      return this.sitesGroup ? this.siteDataItems.length : this.sitesDataByDate.length
    },
    siteDataItemsTable: function() {
      if (this.hideZeros) {
        return this.siteDataTable.filter(x => x.requests)
      }

      return this.siteDataTable
    },
  },
  watch: {
  },
  async mounted() {
    // this.userId = JSON.parse(localStorage["auth.currentUser"]).id;
    if (this.canSeeVocentoDashboard) {
      await this.init();
    } else {
      this.$router.push('/')
    }

    this.loading = false;
  },
  methods: {
    async embedDashboard(){
      let dashboardId;


      if (this.isAdmin || this.isEyeo) {
        dashboardId = "30cc4608-028e-4091-bf5b-37acfdd8dc73";
      } else {
        dashboardId = "30cc4608-028e-4091-bf5b-37acfdd8dc73"
      }

      const dashboardResponse = await Axios.get(`${process.env.VUE_APP_API_URL}aws/embeddedURL/${dashboardId}`);
      const url = dashboardResponse.data.EmbedUrl;

      const options = {
          url,
          container: this.$refs.embeddingContainer,
          parameters: {},
          scrolling: "no",
          height: 'AutoFit',
          width: '100%',
          iframeResizeOnSheetChange: true, // use this option in combination with height: AutoFit, to allow iframe height to resize dynamically, based on sheet height, on changing sheets.
          locale: "en-US",
          footerPaddingEnabled: false,
          parametersChangeCallback: () => {},
          // sheetId: sheetId, // use this option to specify initial sheet id to load for the embedded dashboard
          // sheetTabsDisabled: sheetTabsDisabled, // use this option to enable or disable sheet tab controls in dashboard embedding
          printEnabled: false, // use this option to enable or disable print option for dashboard embedding
          undoRedoDisabled: true, // set this option to true to disable undo and redo buttons for dashboard embedding
          resetDisabled: true, // set this option to true to disable reset button for dashboard embedding
      };

      embedDashboard(options);
    },

    async init() {
      this.loading = true;
      this.showEmbeddedContainer=false;
      await this.embedDashboard()
      this.loading = false;
    },
  }
}
</script>

<template>
  <Layout>
      <div class="row home-page">
            <div class="col-12">
              <div class="page-title-box">
                <h4 class="page-title-left mt-4">Vocento Dashboard </h4>


              </div>
            </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div ref="embeddingContainer">
          </div>
        </div>
      </div>
  </Layout>
</template>


<style lang="scss">

  .see-as-label {

  }

  .mode-selector {
    text-align: right;
  }

  .revenue-ribbon {
    position: absolute!important;
    top: 5px!important;
  }

  .home-page {
    .site-select {
      height: 35px !important;
    }
    .home-date-picker {
      width: 240px!important;
    }
    .mx-shortcuts {
      font-weight: bold!important;
      text-decoration: underline;
    }
    .download-btn {
      height: 32px;
      line-height: 18px;
    }

    .multiselect__content-wrapper {
      width: 100%!important;

    }
    .multiselect__tags {
      max-width: 400px!important;
      min-width: 300px!important;
      height: 37px;
      overflow: scroll !important;
      margin-top: 1.5px;
    }
    ::-webkit-scrollbar
    {
        width:0px;
        height:0px;
    }
    .flex-form{
    display: flex;
    flex-direction: row;
    align-items: flex-start !important;
    }

  }

  .field{
    font-weight: 300;
  }
  .widget-card-unit{
    border-radius: 8px;
    // box-shadow: 1px 2px 6px#dee2e6;
  }

  .static-domain{
    font-size: 1.1rem;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;

  }
  .category{
    font-size: 0.9rem;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;

  }
  .pie-chart{
    box-sizing: border-box;
    border: 3px white solid;
    border-radius: 10px;
    padding-bottom: 20px;
    p{
      font-size: 1rem;
    }
  }

  .apexcharts-slices{
    // transform: scale(1.05) translateY(-5px);
  }

  .apexcharts-legend{
    // transform: translateY(15px);
  }

  .bar-chart{
    box-sizing: border-box;
    border-radius: 10px;
    margin: 2px;
    p{
      font-size: 1rem;
      position: relative;
      bottom: 0.7rem;
      padding:0 20px;
    }
  }

  .bg-light{
    background-color: rgba($color: #f1f5f767, $alpha: 0.5) !important;
  }

  .urgent-alert{
    z-index: 100;
    position: fixed;
    bottom: 1rem;
    right: 4rem;
    width: 40%;
    p{
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }

  .date-conflict{
    line-height: 2.2rem;
    font-size: 1.3rem;
    color: black;
    margin-top:15vh;
  }

  .mdi-alert-circle{
    font-size: 32px;
    line-height: 32px;
    color: #f1556c;
    &:hover {
      color: red;
    }
  }

  .calculator{
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    width:400px;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
    background: #ffd26f;
    .currency-unit,
    .rate-unit{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-bottom: 20px;
      input {
        background-color: #ffd26f;
        color: black;
      }
      img{
        width: 40px;
        border-radius: 2px;
        box-shadow: 5px 2px 5px rgba($color: gray, $alpha: 0.3);
        margin-right: 10px;
      }

    }

    .currency-unit input{
      border:none;
      border-bottom: 1px solid black;
      border-radius: 0;
      text-align:right;
    }
    .rate-unit input {
      width: 80px;
      border: 1px solid black;
    }


  }

  @media (max-width: 768px){
    .static-domain {
    display: none;
    }
    .site-metrics-download{
      display: none;
    }
 }


</style>
